import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Services from './components/Services';
import Projects from './components/Projects';
import Experience from './components/Experience';
import Contact from './components/Contact';
import Footer from './components/Footer';
import CommandPalette from './components/CommandPalette';
import ProjectModal from './components/ProjectModal';
import ErrorBoundary from './components/ErrorBoundary';
import AmbientGlow from './components/AmbientGlow';
import { projectsData } from './data/projects';

function App() {
  const [isCommandPaletteOpen, setIsCommandPaletteOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  // Listen to custom event to open command palette from anywhere
  useEffect(() => {
    const handleOpenPalette = () => setIsCommandPaletteOpen(true);
    window.addEventListener('open-command-palette', handleOpenPalette);
    return () => window.removeEventListener('open-command-palette', handleOpenPalette);
  }, []);

  const handleOpenProject = (projectOrId) => {
    if (typeof projectOrId === 'string') {
      const found = projectsData.find(p => p.id === projectOrId);
      if (found) setSelectedProject(found);
    } else {
      setSelectedProject(projectOrId);
    }
  };

  return (
    <div className="min-h-screen bg-background dark:bg-background-dark selection:bg-primary/20 selection:text-primary overflow-x-hidden w-full relative">
      {/* Ambient Mouse-Following Glow */}
      <AmbientGlow />

      {/* Spotlight Command Palette (Ctrl+K / ⌘K) */}
      <CommandPalette 
        isOpen={isCommandPaletteOpen}
        onClose={() => setIsCommandPaletteOpen(false)}
        onSelectProject={handleOpenProject}
      />

      {/* Case Study Details Modal */}
      <ProjectModal 
        project={selectedProject}
        isOpen={Boolean(selectedProject)}
        onClose={() => setSelectedProject(null)}
      />

      {/* Main Layout */}
      <Header onOpenCommandPalette={() => setIsCommandPaletteOpen(true)} />
      <main>
        <Hero onOpenCommandPalette={() => setIsCommandPaletteOpen(true)} />
        <About />
        <Skills />
        <Services />
        <ErrorBoundary>
          <Projects onSelectProject={handleOpenProject} />
        </ErrorBoundary>
        <Experience />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
